export const getCateringPickupMessage = (formatMessage: Function, storeAddress: string) =>
  `${formatMessage({ id: 'cateringPickUpAt' })}  ${storeAddress}`;
